import React from "react";
import styled from "styled-components";

import { colors } from "../../themes";
import { hsl } from "../../utils/color";
import Button from "../buttons/Button";

const StyledButton = styled(Button)<Props>`
  font-size: inherit;
  font-family: inherit;
  background-color: transparent;
  height: 3rem;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  text-align: left;

  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => hsl(props.theme.colors?.surface3.color)};
  }
`;

interface Props
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  title: string;
  icon?: React.ReactNode;
  iconColor?: colors;
}

const MenuItem: React.FC<React.PropsWithChildren<Props>> = ({
  color,
  ...props
}) => {
  return <StyledButton {...props}>{props.children}</StyledButton>;
};

export default MenuItem;
